import { render, staticRenderFns } from "./spaces_list_item.vue?vue&type=template&id=7e56762b&scoped=true&lang=pug"
import script from "./spaces_list_item.vue?vue&type=script&lang=js"
export * from "./spaces_list_item.vue?vue&type=script&lang=js"
import style0 from "./spaces_list_item.vue?vue&type=style&index=0&id=7e56762b&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e56762b",
  null
  
)

export default component.exports